export type LocalizedValue = {
  tr?: string | null;
  en?: string | null;
} | null | undefined;

const PLACEHOLDER_PATTERNS = [
  "full content in admin",
  "full content on admin",
  "content in admin panel",
  "coming soon",
  "lorem ipsum",
];

export function resolveLocalizedValue(
  value: LocalizedValue,
  base: string | null | undefined,
  lang: "tr" | "en",
) {
  const primary = (lang === "tr" ? value?.tr : value?.en)?.trim();
  if (primary) return primary;

  const secondary = (lang === "tr" ? value?.en : value?.tr)?.trim();
  if (secondary) return secondary;

  return (base ?? "").trim();
}

export function isMeaningfulBlogContent(value: string | null | undefined) {
  const normalized = (value ?? "").trim();
  if (!normalized) return false;
  const lower = normalized.toLowerCase();
  return !PLACEHOLDER_PATTERNS.some((pattern) => lower.includes(pattern));
}

